import depo from './depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import axios from 'axios';
import { UserData } from '../store/user.store';
import router from '../router';
import AuthService from './auth.service';
import { baglantiKesildi, yazmaBasladi, yazmaBitti } from './baglanti';
import { oturumKilitliMi, oturumKapatildiMi, buSekmeyiOturumDisinaAl } from './oturumSenkron';

// Axios interceptor setup
let interceptorSetup = false;
let isRefreshing = false;
let failedQueue = [];

// Tek-uçuş (single-flight) refresh: eşzamanlı 401'ler tek refresh çağrısını paylaşır.
// Tek-kullanımlık DB refresh token'ın paralel isteklerde yarışmasını önler.
let refreshInFlight = null;
export function ensureRefreshed() {
  if (!refreshInFlight) {
    refreshInFlight = AuthService.refreshAccessToken()
      .then(() => true)
      .catch(() => false)
      .finally(() => {
        // Sonraki 401'ler yeni bir refresh tetikleyebilsin
        setTimeout(() => { refreshInFlight = null; }, 0);
      });
  }
  return refreshInFlight;
}

// OT-3: neden = 'kapatildi' → oturum başka cihazdan/Oturumlarım'dan kapatıldı (OturumSuresiBitti metni).
function _clearAuthAndExpire(neden) {
  // OT-3e: kapatılan oturum (neden=kapatildi) sunucuda bitti — başka sekmenin anahtarı da geçersiz, beklenmez.
  if (!AuthService.yerelOturumuSil(undefined, !!neden)) return; // başka sekme yeniledi → bu sekme onunla devam
  buSekmeyiOturumDisinaAl(router, neden ? { path: '/oturum-suresi-bitti', query: { neden } } : { path: '/oturum-suresi-bitti' });
}

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  isRefreshing = false
  failedQueue = []
}

function setupInterceptors(store) {
  if (interceptorSetup) return;
  
  // Response interceptor - 401 gelirse refresh token dene
  axios.interceptors.response.use(
    response => response,
    error => {
      const originalRequest = error.config;

      // Do not try to refresh when the failing request is the token endpoint itself
      if (originalRequest && originalRequest.url && originalRequest.url.toLowerCase().includes('/token')) {
        return Promise.reject(error);
      }

      // Avoid retry loops
      if (originalRequest && originalRequest._retry) {
        return Promise.reject(error);
      }

      // OT-3: oturum kapatıldı → yenileme denenmez (satır silindi, yenileme de reddedilir)
      if (oturumKapatildiMi(error.response)) {
        _clearAuthAndExpire('kapatildi');
        return Promise.reject(error);
      }

      if (error.response && error.response.status === 401) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          }).then(token => {
            originalRequest.headers['Authorization'] = 'bearer ' + token;
            originalRequest._retry = true;
            return axios(originalRequest);
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        return new Promise((resolve, reject) => {
          AuthService.refreshAccessToken()
            .then(() => {
              const newToken = depo.oku('token');
              originalRequest.headers['Authorization'] = 'bearer ' + newToken;
              processQueue(null, newToken);
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              processQueue(err, null);
              // OT-3e: tek yardımcı — başka sekme yenilediyse silinmez, bu sekme de yönlenmez
              if (AuthService.yerelOturumuSil()) {
                if (store) {
                  store.dispatch('auth/logout', null, { root: true });
                }
                buSekmeyiOturumDisinaAl(router, { path: '/oturum-suresi-bitti' });
              }
              reject(err);
            });
        });
      }

      if (error.response && error.response.status === 403) {
        if (router) {
          const currentPath = router.currentRoute && router.currentRoute.value
            ? (router.currentRoute.value.path || '').toLowerCase()
            : '';
          if (currentPath !== '/hata-erisim-yetkisi') {
            router.push({ path: '/hata-erisim-yetkisi' });
          }
        }
        return Promise.reject(error);
      }

      // error.response YOKSA istek sunucuya hiç ulaşmadı / yanıt hiç gelmedi (DNS, bağlantı reddi,
      // zaman aşımı) — validateStatus:()=>true kullandığımız için normal HTTP hataları (400/401/…)
      // zaten response ile buraya değil .then()'e düşer. Bu, gerçek bir "bağlantı koptu" sinyali.
      if (!error.response) {
        baglantiKesildi();
      }

      return Promise.reject(error);
    }
  );
  
  interceptorSetup = true;
}

// TKD-3 (K1): gövdedeki Date nesneleri YEREL "yyyy-MM-ddTHH:mm:ss" metnine çevrilir (Z yok).
// JSON'un varsayılanı toISOString() (UTC) idi: Türkiye'de 05.10 00:00 → "2026-10-04T21:00:00Z" →
// BE gün kısmını alınca kayıt 1 gün geri gidiyordu. Kendisi metne çeviren ekranlar etkilenmez.
// FormData / Blob / dosya gövdeleri olduğu gibi geçer; çağıranın nesnesi değiştirilmez (kopya).
function _ikiHane(n) { return String(n).padStart(2, '0'); }
export function yerelTarihMetni(d) {
  if (isNaN(d.getTime())) return null;
  return d.getFullYear() + '-' + _ikiHane(d.getMonth() + 1) + '-' + _ikiHane(d.getDate()) +
    'T' + _ikiHane(d.getHours()) + ':' + _ikiHane(d.getMinutes()) + ':' + _ikiHane(d.getSeconds());
}
export function tarihleriYerellestir(v, derinlik = 0) {
  if (v instanceof Date) return yerelTarihMetni(v);
  if (v === null || typeof v !== 'object' || derinlik > 20) return v;
  if (Array.isArray(v)) return v.map((x) => tarihleriYerellestir(x, derinlik + 1));
  const proto = Object.getPrototypeOf(v);
  if (proto !== Object.prototype && proto !== null) return v; // FormData, Blob, File, URLSearchParams, ArrayBuffer…
  const kopya = {};
  Object.keys(v).forEach((k) => { kopya[k] = tarihleriYerellestir(v[k], derinlik + 1); });
  return kopya;
}

export function Servis(Type, URL, DemandData, store, _retry) {
    let ServiceURL = null;
    if (process.env.NODE_ENV === 'production') {
      ServiceURL = 'https://api.hepy.app/api/'
    }
    else {
      ServiceURL = 'https://localhost:44386/api/'
    }

    // Interceptor setup
    setupInterceptors(store);

    // OT-3: bu tarayıcıda başka hesapla girildi (katman açık) — bu sekme eski hesabın ekranına istek atmaz.
    if (oturumKilitliMi()) return new Promise(() => {});

    const isAuthEndpoint = /login|logout/i.test(String(URL));

    // Kesinti anında bekleyen bir KAYDET/SIL isteği varsa, bağlantı dönünce kullanıcıyı
    // "işleminiz kaydedilmemiş olabilir" diye açıkça uyarmak için (bkz. services/baglanti.js).
    const isWrite = /^(POST|PUT|DELETE|PATCH)$/i.test(Type);
    if (isWrite) yazmaBasladi();

    return axios({
      method: Type.toUpperCase(),
      data: tarihleriYerellestir(DemandData),
      headers: {
        'api-version': '1.0',
        contentType: 'application/x-www-form-urlencoded',
        Authorization: 'bearer ' + UserData.getters.getuserData,
      },
      url: ServiceURL + URL,
      validateStatus: function () { return true; },
    }).then((response) => {
      // OT-3: oturum başka yerden kapatıldı → yenileme yok, doğrudan "kapatıldı" ekranı
      if (!isAuthEndpoint && oturumKapatildiMi(response)) {
        _clearAuthAndExpire('kapatildi');
        return response;
      }
      // 401 → refresh token ile şeffaf yenile ve isteği bir kez tekrarla
      if (response && response.status === 401 && !_retry && !isAuthEndpoint
          && depo.oku('refreshToken')) {
        return ensureRefreshed().then((ok) => {
          if (ok) {
            // Yeni token ile aynı isteği tekrarla
            return Servis(Type, URL, DemandData, store, true);
          }
          // Refresh başarısız → oturum sonlandı
          _clearAuthAndExpire();
          return response;
        });
      }
      return response;
    }).finally(() => {
      if (isWrite) yazmaBitti();
    })
}